/**
 * @generated SignedSource<<1a8b7abeac2d20bb0605d73dd5b6e8e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type messageDispatchForm_Query$variables = {
  id: string;
  skip: boolean;
};
export type messageDispatchForm_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"messageDispatchForm_MessageDispatchFragment">;
};
export type messageDispatchForm_Query = {
  response: messageDispatchForm_Query$data;
  variables: messageDispatchForm_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isDispatchCondition"
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootNodeIds",
    "storageKey": null
  },
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = [
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AccountDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "AllUserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userIds",
        "storageKey": null
      },
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "type": "UserDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeStartedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeFinishedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v7/*: any*/),
    "type": "TreeUnlockedDispatchCondition",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": (v6/*: any*/),
    "type": "OptInDispatchCondition",
    "abstractKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "messageDispatchForm_Query",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "messageDispatchForm_MessageDispatchFragment"
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "messageDispatchForm_Query",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sendAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MessageDefinition",
                    "kind": "LinkedField",
                    "name": "messageDefinition",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "internalTitle",
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "includes",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "excludes",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "MessageDispatch",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8cbcdbe10ca44ee6057aeb6eb9a31ce7",
    "id": null,
    "metadata": {},
    "name": "messageDispatchForm_Query",
    "operationKind": "query",
    "text": "query messageDispatchForm_Query(\n  $id: ID!\n  $skip: Boolean!\n) {\n  ...messageDispatchForm_MessageDispatchFragment_1Bmzm5 @skip(if: $skip)\n}\n\nfragment dispatchConditionDropdown_MessageDispatchFragment on MessageDispatch {\n  id\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n}\n\nfragment dispatchConditionsPreview_MessageDispatchFragment on MessageDispatch {\n  id\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n}\n\nfragment dispatchExclusions_MessageDispatchFragment on MessageDispatch {\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  ...dispatchConditionDropdown_MessageDispatchFragment\n  ...dispatchConditionsPreview_MessageDispatchFragment\n  id\n}\n\nfragment dispatchInclusions_MessageDispatchFragment on MessageDispatch {\n  includes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  excludes {\n    __typename\n    ... on AccountDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on AllUserDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on UserDispatchCondition {\n      userIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeStartedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeFinishedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on TreeUnlockedDispatchCondition {\n      rootNodeIds\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    ... on OptInDispatchCondition {\n      kind\n      ...removeDispatchConditionButton_DispatchConditionFragment\n    }\n    id\n  }\n  ...dispatchConditionDropdown_MessageDispatchFragment\n  ...dispatchConditionsPreview_MessageDispatchFragment\n  id\n}\n\nfragment messageDispatchForm_MessageDispatchFragment_1Bmzm5 on Query {\n  node(id: $id) {\n    __typename\n    ... on MessageDispatch {\n      id\n      sendAt\n      messageDefinition {\n        internalTitle\n        id\n      }\n      includes {\n        __typename\n        id\n      }\n      ...dispatchInclusions_MessageDispatchFragment\n      ...dispatchExclusions_MessageDispatchFragment\n    }\n    id\n  }\n}\n\nfragment removeDispatchConditionButton_DispatchConditionFragment on DispatchCondition {\n  __isDispatchCondition: __typename\n  id\n}\n"
  }
};
})();

(node as any).hash = "86b19359d0098003b86b8c950eef13ef";

export default node;
